import React from 'react';
import { Box, Container, Skeleton } from '@mui/material';
import StyledBox from 'views/rebranded-module/common/motorcycle-rides-module/RidesViewV2/RidesViewV2.styles';
import HeroSectionStyledBox from 'views/rebranded-module/common/motorcycle-rides-module/RidesViewV2/components/HeroSection/HeroSection.styles';
import { RidesListSectionSkeleton } from 'views/rebranded-module/common/motorcycle-rides-module/RidesViewV2/components';

const RidesViewV2Skeleton = () => {
    return (
        <StyledBox>
            {/* Hero Section Skeleton */}
            <HeroSectionStyledBox>
                <Box className="HSBGContainer">
                    <Skeleton variant="rectangular" width="100%" height="100%" />
                </Box>
                <Box className="HSBGGradient" />
                <Box className="HSBGPattern">
                    <Skeleton variant="rectangular" width="100%" height="100%" />
                </Box>
                <Box className="HSContentContainer">
                    <Skeleton variant="text" width="60%" height={60} sx={{ mb: 1.75 }} />
                    <Skeleton variant="text" width="80%" height={24} />
                </Box>
            </HeroSectionStyledBox>

            {/* Filter and List Container */}
            <Box className="RVFilterAndListContainer">
                <Box className="RVBGPattern">
                    <Skeleton variant="rectangular" width="100%" height="100%" />
                </Box>
                <Container maxWidth="xxl" className="RVCustomContainer">
                    {/* Filter Section Skeleton */}
                    <Box mb={4}>
                        <Skeleton variant="rectangular" width={300} height={56} />
                    </Box>

                    {/* Rides List Section Skeleton */}
                    <RidesListSectionSkeleton />
                </Container>
            </Box>
        </StyledBox>
    );
};

export { RidesViewV2Skeleton };

